<div>
  <span>{{orderItem.ID}}</span>
  <span>{{orderItem.quantity}}</span>
</div>
